/**
 * @param  {string} src
 */
const loadJavascriptFile = (src) => {
    let s = document.createElement("script");
    s.type = "text/javascript";
    s.async = true;
    s.src = src;
    let x = document.getElementsByTagName("script")[0];
    x.parentNode.insertBefore(s, x);
}

export default loadJavascriptFile;
